import { Tabs as DaisyTabs } from 'react-daisyui';
import { TAB_OPTIONS } from './helper';

const Tabs = ({ activeTab, counts, onTabChange }) => (
  <DaisyTabs variant="bordered" className="mb-1">
    {TAB_OPTIONS.map(({ id, label, activeBorder, pill }) => {
      const isActive = activeTab === id;

      return (
        <DaisyTabs.Tab
          key={id}
          role="tab"
          active={isActive}
          onClick={() => onTabChange(id)}
          className={`h-auto gap-2 px-1 pb-3 text-[15px] font-bold transition-colors ${
            isActive ? `${activeBorder} text-secondary-900` : 'text-secondary-400 hover:text-secondary-600'
          }`}
        >
          {label}
          <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${pill}`}>{counts[id] ?? 0}</span>
        </DaisyTabs.Tab>
      );
    })}
  </DaisyTabs>
);

export default Tabs;
